import type { ReactNode } from "react";
import { BookOpen, Gauge, LogOut, Plus, Settings, Sparkles } from "lucide-react";
import type { Accent, Deck, Settings as AppSettings } from "../../shared/types";
import { Brand } from "./Brand";

export type ViewName = "dashboard" | "decks" | "deck" | "deckEdit" | "add" | "detail" | "studySetup" | "study" | "settings";

const nav = [
  ["dashboard", "Tổng quan", Gauge],
  ["decks", "Bộ từ", BookOpen],
  ["add", "Thêm từ", Plus],
  ["studySetup", "Học ngay", Sparkles],
  ["settings", "Cài đặt", Settings],
] as const;

export function AppShell({ children, view, onNavigate, onSignOut, decks, settings, onAccentChange }: {
  children: ReactNode;
  view: ViewName;
  onNavigate: (view: ViewName) => void;
  onSignOut: () => void;
  decks: Deck[];
  settings: AppSettings | null;
  onAccentChange: (accent: Accent) => void;
}) {
  const active = view === "study" ? "studySetup" : ["deck", "deckEdit", "detail"].includes(view) ? "decks" : view;
  return (
    <div className="app-shell">
      <aside className="sidebar">
        <Brand />
        <nav aria-label="Điều hướng chính">
          {nav.map(([name, label, Icon]) => (
            <button key={name} className={active === name ? "active" : ""} onClick={() => onNavigate(name)}>
              <Icon size={19} aria-hidden="true" /><span>{label}</span>
            </button>
          ))}
        </nav>
        <div className="sidebar-footer">
          <label htmlFor="side-accent">Giọng đọc</label>
          <select id="side-accent" value={settings?.pronunciation_accent ?? "us"} onChange={(event) => onAccentChange(event.target.value as Accent)}>
            <option value="us">US Accent</option>
            <option value="uk">UK Accent</option>
          </select>
          <button onClick={onSignOut}><LogOut size={18} aria-hidden="true" /><span>Đăng xuất</span></button>
        </div>
      </aside>
      <div className="mobile-topbar">
        <Brand compact />
        <div className="mobile-top-actions"><button className="icon-button" title="Bắt đầu học" aria-label="Bắt đầu học" onClick={() => onNavigate("studySetup")}><Sparkles size={20} /></button><button className="icon-button" title="Đăng xuất" aria-label="Đăng xuất" onClick={onSignOut}><LogOut size={19} /></button></div>
      </div>
      <main>{children}</main>
      <nav className="mobile-nav" aria-label="Điều hướng di động">
        {nav.map(([name, label, Icon]) => (
          <button key={name} className={active === name ? "active" : ""} onClick={() => onNavigate(name)}>
            <Icon size={19} aria-hidden="true" /><span>{label}</span>
          </button>
        ))}
      </nav>
      <aside className="right-rail" aria-label="Thông tin nhanh">
        <section className="card rail-card">
          <h2>Tiến độ bộ từ</h2>
          {decks.slice(0, 5).map((deck) => <div className="rail-row" key={deck.id}><span>{deck.name}</span><b>{deck.item_count}</b></div>)}
          {!decks.length ? <p className="empty">Chưa có bộ.</p> : null}
          <button onClick={() => onNavigate("decks")}>Quản lý bộ từ</button>
        </section>
        <section className="card rail-card">
          <h2>Thêm từ nhanh</h2>
          <p className="muted">Dán dữ liệu 9 trường cho một hoặc nhiều từ.</p>
          <button className="primary" onClick={() => onNavigate("add")}>Mở nhập nhanh</button>
        </section>
      </aside>
    </div>
  );
}
